const UserRolesEnum = Object.freeze({
  CUSTOMER: '3YNDHI0UAj',
  INTERESTED: 'TX33Q0JKII',
  PARTNER: 'aEd1ctljHv',
  EMPLOYER: 'fnIFm93MjT',
  CONTRACTOR: 'JH78ho9gd6',
  TROLLEYMAKER: 'riTooR4Z2e'
})
export default UserRolesEnum
